import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "/advertiser/packages"
const options = {role: ROLE.ADVERTISER};

export const getAllPackages = async (values) => {
    return await axiosInstance(options).get(`${path}/list-packages`, values);
}

export const getPurchaseHistory = async (values) => {
    return await axiosInstance(options).get(`${path}/purchase-history`, values);
}
